import { cn } from "@/lib/hooks/utils";
import { Button } from "@/ui-components/ui/button";
import {
  Command,
  CommandEmpty,
  CommandGroup,
  CommandInput,
  CommandItem,
  CommandList,
} from "@/ui-components/ui/command";
import { Popover, PopoverContent, PopoverTrigger } from "@/ui-components/ui/popover";
import { Check, ChevronsUpDown } from "lucide-react";
import { useState } from "react";

const journeyStates = [
  { value: "all", label: "Alle Status" },
  { value: "start", label: "Start" },
  { value: "no-interest", label: "Kein Interesse (Verloren)" },
  { value: "wasnt-there", label: "Nicht anwesend (Ausstehend)" },
  { value: "thinking", label: "Überlegt (Ausstehend)" },
  { value: "received-offer", label: "Angebot erhalten (Ausstehend)" },
  { value: "didnt-sell", label: "Nicht verkauft (Verloren)" },
  { value: "sold", label: "Verkauft (Gewonnen)" },
  { value: "technical-not-possible", label: "Technisch nicht möglich (Verloren)" },
];

interface JourneyFilterProps {
  value: string;
  onValueChange: (value: string) => void;
}

export function JourneyFilter({ value, onValueChange }: JourneyFilterProps) {
  const [open, setOpen] = useState(false);

  const selectedState = journeyStates.find((state) => state.value === value);

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button variant="outline" role="combobox" aria-expanded={open} className="w-[240px] justify-between">
          {selectedState ? selectedState.label : "Nach Status filtern"}
          <ChevronsUpDown className="ml-2 h-4 w-4 shrink-0 opacity-50" />
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-[240px] p-0">
        <Command>
          <CommandInput placeholder="Status suchen..." />
          <CommandList>
            <CommandEmpty>Kein Status gefunden.</CommandEmpty>
            <CommandGroup>
              {journeyStates.map((state) => (
                <CommandItem
                  key={state.value}
                  value={state.value}
                  onSelect={(currentValue) => {
                    onValueChange(currentValue);
                    setOpen(false);
                  }}
                >
                  <Check className={cn("mr-2 h-4 w-4", value === state.value ? "opacity-100" : "opacity-0")} />
                  {state.label}
                </CommandItem>
              ))}
            </CommandGroup>
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  );
}
